export const GET_FRUITS_REQUEST = "GET_FRUITS_REQUEST";
export const GET_FRUITS_SUCCESS = "GET_FRUITS_SUCCESS";
export const GET_FRUITS_FAILURE = "GET_FRUITS_FAILURE";